import React from 'react'

export const Fallback = () => {
  return (
    <>
      <h3>Oops! an error occured, must have exceeded 10 counts. Please try again later</h3>
    </>
  )
}
